module.exports = __webpack_public_path__ + "static/media/Plateau_L_2.4bfe82a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/Plateau_L_2.svg
// module id = 787
// module chunks = 0